import { Form } from 'antd';
import styled, { css } from 'styled-components';
import { tangerineGradient } from '../../styles';

export const FormContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
`;

export const RangeInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 0 5px;
`;

export const Title = styled.h3`
  font-weight: normal;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 16px;
  text-align: center;
  color: ${props => props.theme.colors.black};
`;

export const SubTitle = styled.h4`
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;  
  color: ${({ theme }) => theme.colors.fontSilverPrimary};
  margin-bottom: 16px;
  
  p {
    margin-bottom: 5px;
  }
`;

export const StatusLogValue = styled.span`
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  margin: 8px;
  color: ${({ color }) => color};
`;

export const StatusLog = styled.div`
  height: 44px;
  background-color: ${({ theme }) => theme.colors.lightGreySilver};
  padding: 13px;
  border-radius: 5px;
  margin-bottom: 13px;
`;

export const FormFieldAdd = styled.button`
  height: 21px;
  background-color: ${({ theme }) => theme.colors.carnation};
  color: ${({ theme }) => theme.colors.fontTangerine};
  border: none;
  border-radius: 2px;
  margin-top: 7px;
  outline: none;
  cursor: pointer;
  display: ${({ hideBtn }) => hideBtn && 'none'};
`;

export const FormFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  min-height: 75px;
  padding: 14px 18px;
  border: 1px solid ${({ theme }) => theme.colors.whiteLilac};
  border-radius: 4px;
  margin: 5px;
`;

export const FormFieldLabel = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.fontSilverLight};
`;

export const RangeButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 35px;
  text-align: center;
`;

const FormItem = Form.Item;
export const FormItemS = styled(FormItem)`
  max-width: 108px;
  margin: 5px 0 12px 0;
  text-align: left;
  font-size: 13px;

  .has-error .ant-form-explain,
  .has-error .ant-form-split {
    margin-top: 2px;
    margin-bottom: -15px;
  }
`;

export const FormErrorWrapper = styled(FormItem)`
 margin-bottom: ${({ message }) => message ? '24px' : '0px'};
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: start;
`;

export const FormFieldButton = styled.button`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  border: 1px solid ${({ theme }) => theme.colors.borderLightSilver};
  box-sizing: border-box;
  border-radius: 2px;
  min-height: 21px;
  color: ${({ cancel, theme }) => cancel ? theme.colors.lightRed : theme.colors.black};
  background-color: ${({ cancel, theme }) => cancel ? theme.colors.lightPink : theme.colors.white};
  outline: none;
  margin-right: 6px;
  cursor:${({ disabled }) => disabled && 'not-allowed'};
  
  :hover {
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  }
`;

export const FormFieldActions = styled.div`
  margin-top: 10px;
`;

export const BudgetView = styled.div`
  margin: 10px 0 0 0;
  color: ${({ theme }) => theme.colors.black};
  text-align: start;
`;

export const ReactQuillWrappedContainer = styled.div`
   width: 100%;
   text-align: start;
`;

export const ContentWrapper = styled.div`
  display: flex;
  text-align: start;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  
  form {
  width: 100%;
  }
  
  .quill {
    margin-top: 10px;
  }
`;

export const TaskList = styled.div`
  display:${({ display }) => display ? 'block' : 'none'};
  margin-top: 9px;
  width: 100%;
`;

export const FormAddTask = styled.div`
  width: 100%;
  display: flex;
  align-items:${({ changePosition }) => changePosition ? 'center' : 'start'}; 
  justify-content: ${({ changePosition }) => changePosition && 'space-between'};
  flex-direction: ${({ changePosition }) => !changePosition && 'column'};
`;

export const ModalButton = styled.button`
  min-width: 105px;
  width:${({ width }) => `${width}px`}
  height: 43px;
  left: 419px;
  top: 687px;
  outline: none;
  border: ${({ noActionBtn, theme }) => noActionBtn ? `1px solid ${theme.colors.geyser}` : 'none'};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 5px;
    
  :hover {
  cursor: pointer;
  }
`;

export const ModalButtonGradient = styled.button`
  width: 245px;
  height: 43px;
  left: 419px;
  top: 687px;
  outline: none;
  border: none;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.white};
   
  ${tangerineGradient}
  
  :hover {
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  }
`;

export const LabelSelectWrapper = styled.div`
  margin-top: 7px;
  min-width: 100%;
`;

export const LabelHistoryWrapper = styled.div`
  margin-top: 7px;
  text-align: left;
  
  ${({ showBottomBorder, theme }) => showBottomBorder && css`
    padding-bottom: 7px;
    border-bottom: 1px solid ${theme.colors.whiteLilac};
  `};

  & > span {
    font-size: 13px;
    margin-right: 7px;
    color: ${({ theme }) => theme.colors.fontSilverLight};
  }
`;

export const Label = styled.div`
  display: inline-block;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 5px;
  width: max-content;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${props => props.bgColor};
  margin: 1px;
`;



// WEBPACK FOOTER //
// ./src/modals/change-status/styled-components.js